module.exports = __webpack_public_path__ + "img/codigo-postal.3b922415.png";